import {
  IconButton,
  InputAdornment,
  type InputProps,
  Stack,
  TextField,
  type TextFieldProps
} from '@mui/material'
import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useBoolean } from 'react-use'

import Icon from 'components/Icon'

export const PasswordTextField = React.forwardRef<
  React.Ref<HTMLInputElement | HTMLTextAreaElement>,
  {
    canToggle?: boolean
    canCopy?: boolean
    InputProps?: InputProps
  } & TextFieldProps
>(({ canToggle = true, canCopy = false, value, InputProps, ...rest }, ref) => {
  const [showPassword, setShowPassword] = useBoolean(false)
  const [isCopied, setIsCopied] = useBoolean(false)

  return (
    <TextField
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <Stack direction="row" spacing={1}>
              {canToggle && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.preventDefault()
                    setShowPassword(!showPassword)
                  }}
                >
                  <Icon icon={showPassword ? 'eyeSlash' : 'eye'} />
                </IconButton>
              )}
              {canCopy && (
                <CopyToClipboard text={value} onCopy={() => setIsCopied(true)}>
                  <IconButton
                    aria-label="copy-to-clipboard"
                    color="inherit"
                    size="small"
                  >
                    <Icon icon={isCopied ? 'circleCheck' : 'copy'} />
                  </IconButton>
                </CopyToClipboard>
              )}
            </Stack>
          </InputAdornment>
        )
      }}
      inputRef={ref}
      type={showPassword ? 'text' : 'password'}
      value={value}
      {...rest}
    />
  )
})
